<template>
  <div>
    <Head title="DASHBOARD - EMPRESA" />
    <div class="w-full p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase lg:w-6/12">
        DASHBOARD - EMPRESA {{ company.name }} - ({{ company.cnpj }})
      </h1>

      <Link :href="'/companies-dashboard/report/' + company.id" class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full lg:w-2/12">
        <span><font-awesome-icon icon="fa-file-pdf" class="text-primary text-lg cursor-pointer" />Emitir PDF</span>
    </Link>

      
      <div class="mb-14 lg:flex gap-11">
        <div class="w-full flex items-center gap-10">
          <div class="px-5 py-10 mb-10 w-full max-w-sm shadow-lg rounded-md">
            <div class="flex items-center justify-between">
              <div
                class="w-16 h-16 rounded-full bg-primary text-white text-2xl flex items-center justify-center"
              >
                <font-awesome-icon icon="fa-users" />
              </div>

              <p class="font-bold text-6xl text-gray-400">
                {{ totalEmployees }}
              </p>
            </div>

            <p class="text-lg font-bold mt-4">
              Quantidade total de funcionários
            </p>
          </div>

          <div class="px-5 py-10 mb-10 w-full max-w-sm shadow-lg rounded-md">
            <div class="flex items-center justify-between">
              <div
                class="w-16 h-16 rounded-full bg-primary text-white text-2xl flex items-center justify-center"
              >
                <font-awesome-icon icon="fa-person-arrow-up-from-line" />
              </div>

              <p class="font-bold text-6xl text-gray-400">
                {{ totalEmployeesUp }}
              </p>
            </div>

            <p class="text-lg font-bold mt-4">Funcionários ativos</p>
          </div>

          <div class="px-5 py-10 mb-10 w-full max-w-sm shadow-lg rounded-md">
            <div class="flex items-center justify-between">
              <div
                class="w-16 h-16 rounded-full bg-primary text-white text-2xl flex items-center justify-center"
              >
                <font-awesome-icon icon="fa-person-arrow-down-to-line" />
              </div>

              <p class="font-bold text-6xl text-gray-400">
                {{ totalEmployeesDown }}
              </p>
            </div>
            <p class="text-lg font-bold mt-4">Funcionários inativos</p>
          </div>

          <div class="px-5 py-10 mb-10 w-full max-w-sm shadow-lg rounded-md">
            <div class="flex items-center justify-between">
              <div
                class="w-16 h-16 rounded-full bg-primary text-white text-2xl flex items-center justify-center"
              >
                <font-awesome-icon icon="fa-hospital-user" />
              </div>
              <p class="font-bold text-6xl text-gray-400">
                {{ totalApointiments }}
              </p>
            </div>

            <p class="text-lg font-bold mt-4">Quantidade de atendimentos</p>
            
          </div>
        </div>
        
      </div>
      <div v-if="loadTable" class="mb-14 lg:flex gap-12">
        <div class="flex flex-wrap m-auto my-0">
          <div class="mb-5 lg:mb-10 w-full lg:w-7/12 lg:pr-6">
            <div class="w-full mb-6">
              <data-table    
                v-model:columns="columns"
                :disableSearch="true"
                :route="'/companies-dashboard/list/' + company.id"
                no-data-label="this.nolabeldata"
                no-result-label="this.nolabeldata"
              />
            </div>
          </div>
          <div class="mb-10 w-full lg:w-5/12">
            <div class="w-full mb-6">
              <div class="w-full text-center text-xl mb-6 font-poppins">
                Análise de Uso de Planos de Assinatura
              </div>
              <doughnut-chart 
                class="my-6"
                :chart-data="this.chartDoughnutData()"/>
              
            </div>            
          </div>
        </div>
      </div> 
      <div v-if="!loadTable" class="mb-14 lg:flex gap-12">
        <div class="flex flex-wrap w-full">
            <div class="mb-5 lg:mb-10 w-full lg:w-7/12 lg:pr-6">
              <div class="w-full mb-6">
                <table class="w-full mb-6">
                    <thead class="bg-gray-100 font-roboto">
                        <tr>
                            <th class="p-4 text-left">Médico</th>
                            <th class="p-4 text-left">Especialidade</th>
                            <th class="p-4 text-left">Total</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white font-roboto">
                        <tr>
                            <td colspan="3" style="text-align: center; padding: 10% 10% 40% 40%;" class="items-center">
                                <img src="../../../../../public/images/empty-folder.png">
                            </td>
                        </tr>
                    </tbody>

                </table>
              </div>
            </div>
            <div class="mb-10 w-full lg:w-5/12">
              <div class="w-full mb-6">
                <div class="w-full text-center text-xl mb-6 font-poppins">
                  Análise de Uso de Planos de Assinatura
                </div>
                <doughnut-chart 
                  class="my-6"
                  :chart-data="this.chartDoughnutData()"/>
                
                
              </div>            
            </div>
          </div>

      </div>     
    </div>
  </div>
</template>
  
<script>
import { computed } from "vue"
import { Head, usePage, useForm, Link } from "@inertiajs/inertia-vue3"
import starRating from "vue-star-rating"

import Layout from "@/Shared/Layout/Layout"
import LineChart from "@/Shared/Components/LineChart"
import DoughnutChart from "@/Shared/Components/DoughnutChart"
import ProgressChart from "@/Shared/Components/ProgressChart"

import SelectInput from "@/Shared/Fields/SelectInput"
import DateMonthInput from "@/Shared/Fields/DateMonthInput"
import VBarChart from "@/Shared/Components/VBarChart"

import Tabs from "@/Shared/Components/Tabs/Tabs"

import Modal from "@/Shared/Modal/Modal"
import DataTable from "@/Shared/Components/DataTable"
import axios from "axios"

export default {
  components: {
    computed,
    usePage,
    axios,
    Head,
    LineChart,
    DoughnutChart,
    ProgressChart,
    Tabs,
    SelectInput,
    DateMonthInput,
    VBarChart,
    starRating,
    DataTable,
    Modal,
    Link,
  },
  props: {
    
    totalDay: 0,
    totalMonth: 0,
    totalEmployees: 0,
    totalEmployeesUp: 0,
    totalEmployeesDown: 0,
    totalApointiments: 0,
    totalEmployeesBasic: 0,
    totalEmployeesMedium: 0,
    totalEmployeesPremium: 0,
    totalBySpecialty: Object,
    totalByMonth: Object,
    specialty: Array,
    company: Object,
    listCount: 0,
  },
  provide() {
    return {}
  },
  

  data() {
    return {
      patient: null,
      selectedItemIndex: 0,
      barChartFilters: {
        date: null,
        selectedChartView: "profitability",
      },
      chartBarData: null,
      chartDoughnutOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: 150,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      },
      
      loadTable: this.listCount > 0,
      columns: [
        {
          uniqid: "apoint_nameUser",
          label: "Médico",
          field: "nameUser",
          visible: true,
          sortable: true,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.nameUser}`,
        },
        {
          uniqid: "apoint_nameSpeaciality",
          label: "Especialidade",
          field: "nameSpeaciality",
          visible: true,
          sortable: true,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.nameSpeaciality}`,
        },
        {
          uniqid: "apoint_total",
          label: "Qtd de Atendimentos",
          field: "total",
          visible: true,          
          classes:
            "px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.total}`,
        },
      ],
    }
  },
  layout: Layout,

  mounted() {
    const date = new Date()

    this.barChartFilters.date = `${date.getFullYear()}-${date.getMonth() + 1}`
    

  },

  computed: {
    titleChart() {
      return this.barChartFilters.selectedChartView == "profitability"
        ? "Rentabilidade Mensal"
        : "Quantidade de Atendimentos"
    },

    legendMonth() {
      return this.barChartFilters.selectedChartView == "profitability"
        ? "Lucro do mês atual"
        : "Atendimentos do mês atual"
    },

    legendYear() {
      return this.barChartFilters.selectedChartView == "profitability"
        ? "Lucro do ano atual"
        : "Atendimentos do ano atual"
    },

    chartLabel() {
      return this.barChartFilters.selectedChartView == "profitability"
        ? "Lucro"
        : "Atendimentos"
    },

    monthDate() {
      const dateSplited = this.barChartFilters.date.split("-")
      const date = new Date(dateSplited[0], Number(dateSplited[1]) - 1)

      return (
        date.toLocaleDateString("pt-BR", { month: "long" }) +
        "/" +
        date.getFullYear()
      )
    },

    yearDate() {
      return this.barChartFilters.date.split("-")[0]
    },
  },

  watch: {
    "barChartFilters.selectedChartView": function () {},

    "barChartFilters.date": function () {},
  },

  methods: {
    chartDoughnutData() {
      let labels = []
      let colors = []
      let values = []
      labels.push("Plano Básico")
      labels.push("Plano Médio")
      labels.push("Plano Premium")
      colors.push("#6594c4")
      colors.push("#374c69")
      colors.push("#cbbc7e")
      values.push(this.totalEmployeesBasic)
      values.push(this.totalEmployeesMedium)
      values.push(this.totalEmployeesPremium)
      console.log(this.totalEmployeesBasic)
      console.log(this.totalEmployeesMedium)
      console.log(this.totalEmployeesPremium)

      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: colors,
            data: values,
          },
        ],
      }
    },
    
    gerarPDF() {
      
      
      
    },
    
    openWindowWithPost(url, data) {
      axios
        .post(`/companies-dashboard/generate/${this.company.id}`, {
          
        })
        .then((response) => {
          console.log(response.data)
          var base64EncodedPDF = response.data
          var dataURI = "data:application/pdf;base64," +base64EncodedPDF
          window.open(dataURI)
        })
        .catch((error) => {
          console.log(error)
        })

      // form.submit();
      //document.body.removeChild(form);
    },
    generateInput(form, key, value) {
      if (typeof value == "object" && value != null) {
        for (const [obj_key, obj_value] of Object.entries(value)) {
          let k = key + "|" + obj_key
          this.generateInput(form, k, obj_value)
        }
      } else {
        let k = key.split("|")
        if (k.length > 1) {
          for (let i in k) {
            if (i == 0) {
              key = k[i]
            } else {
              key += "[" + k[i] + "]"
            }
          }
        }
        var input = document.createElement("input")
        input.type = "hidden"
        input.name = key
        input.value = typeof value != "undefined" && value != null ? value : ""
        form.appendChild(input)
      }
    },
  },
}
</script>
  